// @flow

import ApiObject from './ApiObject';

export default class GeoPt extends ApiObject {

  longitude: number;

  latitude: number;
}
